// views/chat-builder/sceneTypes.js
// 장면 유형 — 서버 SERVER/chat-core/block/sceneTypes.js 의 **미러**(키·라벨·역할 필요 여부).
// 서버에 유형을 추가·삭제하면 여기도 같이 고친다. 유형별 규칙 문장은 서버가 싣는다 — 여기엔 화면 문구만.
//
// 저장: 스텝 completion.scene = { type, role? }. 지정 안 함이면 필드를 지운다(엔진은 아무것도 싣지 않는다).
// 고른 유형에 따라 [이 스텝의 상황] 칸의 이름·예시가 바뀐다 — 그 칸에는 무대만 적고, 규칙은 유형이 싣는다.

export const SCENE_TYPES = [
	{
		key: "event",
		label: "가정한 장면",
		desc: "그런 일이 있었다고 해 보고, 세부는 사용자가 정해요",
		situationLabel: "장면",
		placeholder: "어떤 장면인지 — 예: 학교 가기 전 아침, 사용자가 늦잠을 잤다. 캐릭터는 같이 등교하려고 기다리던 친구다.",
	},
	{
		key: "talk",
		label: "사용자 이야기",
		desc: "꾸민 장면 없이 사용자의 실제 경험·생각을 들어요",
		situationLabel: "이야기 주제",
		placeholder: "무엇에 대해 이야기하는지 — 예: 사용자가 좋아하는 동물과 (있다면) 키우는 동물",
	},
	{
		key: "roleplay",
		label: "역할극",
		desc: "캐릭터가 정해진 역할을 맡고, 사용자는 자기 자신이에요",
		situationLabel: "역할 놀이 장면",
		placeholder: "어떤 장면인지 — 예: 사용자가 식당에 손님으로 왔다.",
		needsRole: true,
		rolePlaceholder: "캐릭터가 맡을 역할 — 예: 식당 종업원",
	},
];

/** 이 스텝의 장면 유형 정의(없거나 모르는 값이면 null) */
export const sceneOf = (block) => {
	const t = block?.completion?.scene?.type;
	return (t && SCENE_TYPES.find((x) => x.key === t)) || null;
};
